/** OAuth completion may restore only the exact internal destination saved by this user. */
export function takeAnalyticsReturn(
  userId: string,
  state: string,
  organizationId: string | null,
): string {
  const key = `analytics-oauth-return:${userId}`;
  try {
    const raw = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    if (!raw) return "/analytics";
    const saved = JSON.parse(raw) as {
      state?: string;
      path?: string;
      organizationId?: string | null;
    };
    if (
      saved.state !== state ||
      saved.organizationId !== organizationId ||
      !saved.path ||
      !/^\/analytics(?:\/|\?|$)/.test(saved.path)
    )
      return "/analytics";
    const url = new URL(saved.path, window.location.origin);
    return url.origin === window.location.origin
      ? url.pathname + url.search
      : "/analytics";
  } catch {
    return "/analytics";
  }
}
